<script>
import forminput from "../formcomponet/forminput.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import ofirma from "@/models/ofirma";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  mixins: [apibtoast, apigeneric, ofirma],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      ilkodu: "",
    };
  },
  components: {
    Loader,
    forminput,
    formtextarea,
    Treeselect,
  },
  watch: {
    Id() {
      if (this.AddEdit != "DosyaAdd") this.FormData = this.Id;
    },
  },
  created() {
    if (this.AddEdit == "DosyaAdd") {
      this.FormData = this.ofirmaData;
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.FormData.Telefon = this.FormData.Telefon.replace(
          "(",
          ""
        ).toLowerCase();
        this.FormData.Telefon = this.FormData.Telefon.replace(
          ")",
          ""
        ).toLowerCase();
        this.FormData.Telefon = this.FormData.Telefon.replace(
          "-",
          ""
        ).toLowerCase();
        this.FormData.Telefon = this.FormData.Telefon.replace(
          " ",
          ""
        ).toLowerCase();
        if (this.AddEdit == "Add" || this.AddEdit == "DosyaAdd") {
          this.Post("ofirma", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
            }
          });
          this.$bvModal.hide("ofirma");
        } else {
          this.Update("ofirma", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.$emit("TableUpdate");
              this.$bvModal.hide("ofirma");
            }
          });
        }
      }
    },
    ilce_yukle(ustid) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      (this.FormDataType.Adresilceid.ComboDataArray = []),
        this.ActionsFilterGet({ Service: "OIlIlce/" + ustid, Page: Page }).then(
          (res) => {
            this.ilkodu = res.Data.Kod;

            this.ActionsFilterGet({
              Service: "OIlIlce",
              Page: Page,
              Filter: "&Ustid=" + this.ilkodu,
            }).then((res) => {
              for (var i = 0; i < res.Data.length; i++) {
                this.FormDataType.Adresilceid.ComboDataArray.push({
                  id: res.Data[i].Id,
                  label: res.Data[i].Value,
                });
              }
            });
          }
        );
    },

    Get() {
      
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="ofirma"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('ofirma.AddEdit.FormTitleEdit')
          : $t('ofirma.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <forminput
          :FormDataType="FormDataType.Firmaadi"
          :Value="FormData.Firmaadi"
          :v="$v.FormData.Firmaadi"
          @input="FormData.Firmaadi = $event"
        />
        <div class="row">
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Telefon"
              :Value="FormData.Telefon"
              :v="$v.FormData.Telefon"
              @input="FormData.Telefon = $event"
            />
          </div>
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Fax"
              :Value="FormData.Fax"
              :v="$v.FormData.Fax"
              @input="FormData.Fax = $event"
            />
          </div>
        </div>
        <forminput
          :FormDataType="FormDataType.Email"
          :Value="FormData.Email"
          :v="$v.FormData.Email"
          @input="FormData.Email = $event"
        />
        <div class="row">
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Vergino"
              :Value="FormData.Vergino"
              :v="$v.FormData.Vergino"
              @input="FormData.Vergino = $event"
            />
          </div>
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Vergidairesi"
              :Value="FormData.Vergidairesi"
              :v="$v.FormData.Vergidairesi"
              @input="FormData.Vergidairesi = $event"
            />
          </div>
        </div>
        <formtextarea
          :FormDataType="FormDataType.Firmaadresi"
          :Value="FormData.Firmaadresi"
          :v="$v.FormData.Firmaadresi"
          @input="FormData.Firmaadresi = $event"
        />
        <formtextarea
          :FormDataType="FormDataType.Aciklama"
          :Value="FormData.Aciklama"
          :v="$v.FormData.Aciklama"
          @input="FormData.Aciklama = $event"
        />

        <div class="row">
          <div class="col-md-6">
            <b-form-group
              class="mb-3"
              id="example text"
              :label="FormDataType.Adresilid.FieldTitle"
              label-for="text"
            >
              <treeselect
                :multiple="false"
                :options="FormDataType.Adresilid.ComboDataArray"
                :placeholder="$t('OrtakKullanim.seciniz')"
                @input="ilce_yukle(FormData.Adresilid)"
                v-model="FormData.Adresilid"
                :class="{ 'is-invalid': $v.FormData.Adresilid.$error }"
              />
              <treeselect-value :value="FormData.Adresilid" />

              <div v-if="$v.FormData.Adresilid.$error" class="invalid-feedback">
                <span v-if="$v.FormData.Adresilid.required == false">{{
                  $t("ValidationMessage.required")
                }}</span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group
              class="mb-3"
              id="example text"
              :label="FormDataType.Adresilceid.FieldTitle"
              label-for="text"
            >
              <treeselect
                :multiple="false"
                :options="FormDataType.Adresilceid.ComboDataArray"
                :placeholder="$t('OrtakKullanim.seciniz')"
                v-model="FormData.Adresilceid"
                :class="{ 'is-invalid': $v.FormData.Adresilceid.$error }"
              />
              <treeselect-value :value="FormData.Adresilceid" />

              <div
                v-if="$v.FormData.Adresilceid.$error"
                class="invalid-feedback"
              >
                <span v-if="$v.FormData.Adresilceid.required == false">{{
                  $t("ValidationMessage.required")
                }}</span>
              </div>
            </b-form-group>
          </div>
        </div>

        <button class="btn btn-primary" type="submit">
          {{ $t("ofirma.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
